import clsx from 'clsx';
import React from 'react';
import TermsCheckboxIcon from '../icons/CheckboxIcon';

// TODO: add the links to the terms of service and privacy policy

type TermsCheckboxProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
};

export const TermsCheckbox: React.FC<TermsCheckboxProps> = ({ checked, onChange }) => {
  return (
    <div className="flex justify-center w-full px-2 sm:px-4">
      <div className="flex items-start gap-2 max-w-md w-full">
        <div
          className={clsx(
            'w-4 h-4 min-w-[1rem] mt-1 border-2 rounded-sm cursor-pointer flex items-center justify-center flex-shrink-0',
            {
              'border-blue-600 bg-blue-600': checked,
              'border-gray-400 bg-transparent': !checked,
            }
          )}
          onClick={() => onChange(!checked)}
        >
          {checked && <TermsCheckboxIcon />}
        </div>
        <span
          className="text-black text-xs font-normal leading-relaxed text-left min-w-0"
          style={{ fontFamily: 'var(--ep-font-avenir)' }}
        >
          By signing up, you agree to our{' '}
          <span
            className="underline cursor-pointer hover:text-blue-600"
            onClick={() => {
              window.open('/privacy-policy', '_blank');
            }}
          >
            Privacy Policy
          </span>
          .
        </span>
      </div>
    </div>
  );
};
